/* FOLIA — small rotating "active leaf" visual per benefit card. Decorative only; the SVG icon underneath
   is the real fallback and stays visible until this confirms it's actually rendering. */
import * as THREE from './three.module.min.js';

(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const nodes = document.querySelectorAll('[data-folia-card-fx]');
  if (!nodes.length) return;

  const COLORS = {
    leaf: 0x2d4a3a,
    bolt: 0xb8924f,
    heart: 0xe5c9c0,
    shield: 0x2d4a3a,
    flask: 0x2d4a3a
  };

  nodes.forEach(function (canvas) {
    const type = canvas.getAttribute('data-folia-card-fx') || 'leaf';
    initScene(canvas, COLORS[type] || COLORS.leaf);
  });

  function initScene(canvas, color) {
    let renderer;
    try {
      renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true, powerPreference: 'low-power' });
    } catch (e) {
      return;
    }
    renderer.setClearColor(0x000000, 0);

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(40, 1, 0.1, 50);
    camera.position.z = 4.2;

    const core = new THREE.Mesh(
      new THREE.IcosahedronGeometry(1, 0),
      new THREE.MeshStandardMaterial({ color: color, transparent: true, opacity: 0.88, roughness: 0.4, metalness: 0.08, flatShading: true })
    );
    scene.add(core);

    const wire = new THREE.Mesh(
      new THREE.IcosahedronGeometry(1.05, 0),
      new THREE.MeshBasicMaterial({ color: color, wireframe: true, transparent: true, opacity: 0.22 })
    );
    scene.add(wire);

    const keyLight = new THREE.DirectionalLight(0xffffff, 1.1);
    keyLight.position.set(2, 2, 3);
    scene.add(keyLight);
    scene.add(new THREE.AmbientLight(0xffffff, 0.6));

    const ringCount = 12;
    const ringPositions = new Float32Array(ringCount * 3);
    const radius = 1.7;
    for (let i = 0; i < ringCount; i++) {
      const a = (i / ringCount) * Math.PI * 2;
      ringPositions[i * 3] = Math.cos(a) * radius;
      ringPositions[i * 3 + 1] = Math.sin(a) * radius * 0.35;
      ringPositions[i * 3 + 2] = Math.sin(a) * radius * 0.5;
    }
    const ringGeo = new THREE.BufferGeometry();
    ringGeo.setAttribute('position', new THREE.BufferAttribute(ringPositions, 3));
    const ring = new THREE.Points(ringGeo, new THREE.PointsMaterial({ color: color, size: 0.13, transparent: true, opacity: 0.85 }));
    scene.add(ring);

    function size() {
      const w = canvas.clientWidth || 72;
      const h = canvas.clientHeight || 72;
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }

    let visible = false;
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { visible = entry.isIntersecting; });
    }, { threshold: 0.15 });
    io.observe(canvas);

    if (window.ResizeObserver) {
      new ResizeObserver(size).observe(canvas);
    } else {
      window.addEventListener('resize', size);
    }
    size();

    const clock = new THREE.Clock();
    let started = false;
    function animate() {
      requestAnimationFrame(animate);
      if (!visible) return;
      if (!started) {
        started = true;
        const host = canvas.closest('.folia-card__icon');
        if (host) host.classList.add('is-fx-active');
      }
      const t = clock.getElapsedTime();
      core.rotation.y = t * 0.5;
      core.rotation.x = Math.sin(t * 0.3) * 0.3;
      wire.rotation.copy(core.rotation);
      const breathe = 1 + Math.sin(t * 1.4) * 0.06;
      core.scale.setScalar(breathe);
      wire.scale.setScalar(breathe * 1.02);
      ring.rotation.z = t * 0.6;
      renderer.render(scene, camera);
    }
    animate();
  }
})();
